import React, { useState, useEffect } from 'react';
import { LatteButton, LatteSpinner } from '../common';
import '../../styles/common/modal.css';

const CoverImageModal = ({ isOpen, onClose, images, currentCoverImage, onSelectImage, onSave, saving }) => {
  const [selectedImage, setSelectedImage] = useState(currentCoverImage || '');

  // 이미지 배열 디버깅
  useEffect(() => {
    if (isOpen) {
      console.log('CoverImageModal - images:', images);
      console.log('CoverImageModal - currentCoverImage:', currentCoverImage);
      setSelectedImage(currentCoverImage || '');
    }
  }, [images, currentCoverImage, isOpen]);

  if (!isOpen) return null;

  const handleSave = async () => {
    await onSave(selectedImage);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
        <div className="modal-header">
          <h2>커버 이미지 선택</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          {images.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: 'var(--spacing-8)',
              color: 'var(--color-gray-600)'
            }}>
              <p>에디터에 업로드된 이미지가 없습니다.</p>
              <p style={{ marginTop: 'var(--spacing-2)', fontSize: 'var(--font-size-sm)' }}>
                에디터에서 이미지를 추가한 후 다시 시도해주세요.
              </p>
            </div>
          ) : (
            <>
              <p style={{ marginBottom: 'var(--spacing-4)', color: 'var(--color-gray-700)' }}>
                아래 이미지 중 하나를 선택하여 커버 이미지로 설정하세요.
              </p>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: 'var(--spacing-4)',
                maxHeight: '400px',
                overflowY: 'auto',
                padding: 'var(--spacing-2)'
              }}>
                {images.map((imageUrl, index) => (
                  <div 
                    key={`cover-image-${index}`}
                    style={{ 
                      position: 'relative',
                      cursor: 'pointer',
                      border: selectedImage === imageUrl ? '3px solid var(--color-primary)' : '2px solid var(--color-gray-300)',
                      borderRadius: 'var(--border-radius-md)',
                      overflow: 'hidden',
                      backgroundColor: 'var(--color-gray-50)',
                      aspectRatio: '16/9',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => setSelectedImage(imageUrl)}
                  >
                    <img 
                      src={imageUrl} 
                      alt={`이미지 ${index + 1}`}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                        display: 'block'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: var(--color-gray-500);">이미지 로드 실패</div>';
                      }}
                    />
                    {selectedImage === imageUrl && (
                      <div style={{
                        position: 'absolute',
                        top: 'var(--spacing-2)',
                        right: 'var(--spacing-2)',
                        backgroundColor: 'var(--color-primary)',
                        color: 'white',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 'var(--font-size-lg)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}>
                        ✓
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
              {selectedImage && (
                <div style={{ 
                  marginTop: 'var(--spacing-4)', 
                  padding: 'var(--spacing-3)',
                  backgroundColor: 'var(--color-gray-50)',
                  borderRadius: 'var(--border-radius-sm)',
                  fontSize: 'var(--font-size-sm)'
                }}>
                  선택된 이미지: {selectedImage.substring(selectedImage.lastIndexOf('/') + 1)}
                </div>
              )}
            </>
          )}
        </div>
        
        <div className="modal-footer">
          <LatteButton
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={saving}
          >
            취소
          </LatteButton>
          <LatteButton
            type="button"
            variant="primary"
            onClick={handleSave}
            disabled={saving || (images.length > 0 && !selectedImage)}
          >
            {saving ? <LatteSpinner size="sm" /> : '저장'}
          </LatteButton>
        </div>
      </div>
    </div>
  );
};

export default CoverImageModal;
